import React, { useState, useEffect } from 'react'
import {
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    Radio,
    Space,
    Spin,
    Table,
    Divider,
    DatePicker,
    Tag,
    notification
} from "antd";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants';
import TextArea from "antd/lib/input/TextArea";
import { RightOutlined } from "@ant-design/icons";
import accountService from '../../api/account.service';
import commonUtility from '../../utility/Utils';
import moment from 'moment';
import memberService from '../../api/member.service';

const { Option } = Select;

const StudentDueEntry = ({ data, onDrawerClose, onSaveSuccess }) => {
    console.log("data", data);
    const [form] = Form.useForm();
    const [getStudenDueList, setGetStudentDueList] = useState([]);
    const [paymentModeList, setPaymentModeList] = useState([]);
    const [isPaymentModereadOnlyDisable, setIsPaymentModereadOnlyDisable] = useState(false);
    const [bankList, setBankList] = useState([]);
    console.log("bankList", bankList);
    console.log("paymentModeList", paymentModeList);
    const [extraaPaidAmountInfo, setExtraaPaidAmountInfo] = useState("");
    const [saveLoaderEnable, setSaveLoaderEnable] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);

    const [formDataState, setFormDataState] = useState({
        component_id: null,
        payment_id: null,
        programme_id: null,
        enrollment_id: null,
        member_id: null,
        month_id: null,
        receipt_dtl_id: null,
        short_code: null,
        short_excess_cr_ac_id: null,
        bank_id: null
    });

    // Store the data in state when the component mounts
    useEffect(() => {
        if (data) {
            setFormDataState({
                component_id: data[0]?.component_id,
                payment_id: data[0]?.payment_id,
                programme_id: data[0]?.programme_id,
                enrollment_id: data[0]?.enrollment_id,
                member_id: data[0]?.member_id,
                month_id: data[0]?.month_id,
                receipt_dtl_id: data[0]?.receipt_dtl_id,
                short_code: data[0]?.short_code,
                short_excess_cr_ac_id: data[0]?.short_excess_cr_ac_id,

            });
        }
    }, [data]);

    console.log("Stored Form Data:", formDataState);


    const onStudentDueSave = async (values) => {
        setSaveLoaderEnable(true);

        const dateOfPay = values.date_of_pay;
        const fullYear = dateOfPay ? dateOfPay.split('/')[2] : '';


        const data = {
            formData: {
                ...values,
                component_id: formDataState.component_id,
                payment_id: formDataState.payment_id,
                programme_id: formDataState.programme_id,
                member_id: formDataState.member_id,
                enrollment_id: formDataState.enrollment_id,
                month_id: formDataState.month_id,
                receipt_dtl_id: formDataState.receipt_dtl_id,
                short_code: formDataState.short_code,
                short_excess_cr_ac_id: formDataState.short_excess_cr_ac_id,
                bank_id: formDataState.bank_id || "",
                payment_mode_ac_id: paymentModeList[0]?.account_id,
                payment_modes_id: paymentModeList[0]?.id,
                entry_from: 'D',
                full_year: fullYear,
            }
        }
        console.log("Form Values:", data);

        try {
            const response = await memberService.allMemberDuePayment(data);
            console.log("response", response);
            if (response.data.response_status === SUCCESS_STATUS) {
                notification.success({
                    message: 'Saved Successfully',
                    description: response.data.response_msg
                });
                form.resetFields();
                setIsSaveDisabled(true);
                if (onSaveSuccess) {
                    onSaveSuccess(); 
                }
            } else {
                notification.error({
                    message: 'Failed',
                    description: response.data.response_msg,
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Something went wrong!',
            });
        } finally {
            setSaveLoaderEnable(false);
        }
    }

    useEffect(() => {
        accountService.paymentModeList().then((res) => {
            setPaymentModeList(res.data.response_data);
        });
    }, [])

    useEffect(() => {
        accountService.bankList().then((res) => {
            setBankList(res.data.response_data);
        });
    }, [])

    useEffect(() => {
        if (data && data.length > 0) {
            form.setFieldsValue({
                member: data[0]?.member,
                programme_name: data[0]?.programme_name,
                payment_amount: data[0]?.payment_amount,
                due_amount: data[0]?.due_amount,
                payment_date: new Date(data[0]?.payment_date).toLocaleDateString('en-GB'),
                payment_no: data[0]?.payment_no,
                short_name: data[0]?.short_name,
                monthly_paid_amount: data[0]?.monthly_paid_amount,
                payment_no: data[0]?.payment_no,
                net_amount: data[0]?.net_amount,
                paid_amount: data[0]?.due_amount,

            });
        }
    }, [data, form]);

    const formatDate = (date) => {
        return date ? moment(date).format('DD/MM/YYYY') : '';
    };


    const onChequeDateSelect = (date, dateString) => {
        form.setFieldsValue({
            cheque_date: formatDate(date),
        });
    };

    const onPaymentDateSelect = (date, dateString) => {
        const fullYear = date ? moment(date).format('YYYY') : '';
        form.setFieldsValue({
            date_of_pay: formatDate(date),
            full_year: fullYear,
        });
    };

    function disabledDate(current) {

        let sessionData = commonUtility.getLoggedInUserInfo();

        //console.log(sessionData.yearData.year);
        // Range of allowed dates        
        const startDate = new Date(sessionData.yearData.start_date); // Example start date
        const endDate = new Date(sessionData.yearData.end_date);   // Example end date

        // added 1 day to endDate as it is exclude while comparing (i.e March 31 is not selecting)
        endDate.setDate(endDate.getDate() + 1);

        // Return true if the date is not within the range
        return current < startDate || current > endDate;
    }

    const onSelectPaymentMode = (value, object) => {
        console.log("objectMode", object);

        // Reset bank details
        form.setFieldsValue({
            cheque_no: '',
            cheque_date: '',
            bank_name: '',
            branch: '',
            payment_ref: '',
        });

        // Set new payment mode values
        form.setFieldsValue({
            selected_payment_mode_text: object.payment_mode,
            selected_payments_mode: object.id,
            dr_account_id: object.account_id,
            bank_charges: object.bank_charges,
        });

        // Update the paid amount based on the selected payment mode
        onPaymentAmountChange(object);
    }


    const onPaymentAmountChange = (object = null) => {
        console.log("object", object);

        // Reset extra paid amount info
        setExtraaPaidAmountInfo("");

        let bank_charges_amount = 0;
        const paid_amount = commonUtility.sanitizeValue(form.getFieldValue("paid_amount"));

        if (parseFloat(paid_amount) > 0) {
            let bank_charges_amount = 0;
            if (object != null) {
                bank_charges_amount = (parseFloat(paid_amount) * parseFloat(object.bank_charges)) / 100;
            } else {
                const bank_charges = commonUtility.sanitizeValue(form.getFieldValue("bank_charges"));
                bank_charges_amount = (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
            }

            bank_charges_amount = Math.round(bank_charges_amount);

            if (bank_charges_amount > 0) {
                setExtraaPaidAmountInfo(`For Bank Charges you have to pay Rs. ${bank_charges_amount} more`);
            }

            // form.setFieldsValue({ paid_amount});
        }
    }

    const handleBankChange = (value) => {
        const selectedBank = bankList.find(bank => bank.bank_name === value);
        setFormDataState(prevState => ({
            ...prevState,
            bank_id: selectedBank ? selectedBank.bank_id : ""
        }));
    };


    return (
        <div className="form-input-style" style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}>
            <Row gutter={20}>
                <Col xs={24} xl={24}>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onStudentDueSave}
                        autoComplete="off"
                    >
                        <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#333', marginBottom: '20px' }}>
                            Member Details
                        </h2>

                        {/* Member Name and Programme Name */}
                        <Row gutter={20}>
                            <Col xs={24} xl={12}>
                                <Form.Item
                                    name="member"
                                    label="Member Name"
                                >
                                    <Input placeholder="Member Name" size="large" readOnly />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={12}>
                                <Form.Item
                                    name="programme_name"
                                    label="Programme"
                                >
                                    <Input placeholder="Programme Name" size="large" readOnly />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider />

                        {/* Monthly Due */}
                        <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#333', marginBottom: '20px' }}>
                            Monthly Due
                        </h2>
                        <Row gutter={20}>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="short_name"
                                    label="Month"
                                >
                                    <Input placeholder="Month" size="large" readOnly />
                                    {/* <Tag color="blue" size="large" readOnly>{data[0]?.short_name}</Tag> */}
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="net_amount"
                                    label="Fees"
                                >
                                    <Input placeholder="Amount" size="large" readOnly />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="monthly_paid_amount"
                                    label="Paid Amount"
                                >
                                    <Input placeholder="Paid Amount" size="large" readOnly />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="due_amount"
                                    label="Due"
                                >
                                    <Input placeholder="Due Amount" size="large" readOnly />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="payment_no"
                                    label="Receipt No"
                                >
                                    <Input placeholder="Receipt Number" size="large" readOnly />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="payment_date"
                                    label="Payment Date"
                                >
                                    <Input placeholder="Receipt Number" size="large" readOnly />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider />

                        {/* Receipt */}
                        <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#333', marginBottom: '20px' }}>
                            Receipt
                        </h2>
                        <Row gutter={20}>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="date_of_payment"
                                    label="Receipt Date"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Payment date is required",
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        format={DATE_FORMAT_DMY_SLASH}
                                        style={{ width: "100%" }}
                                        inputReadOnly
                                        disabledDate={disabledDate}
                                        onChange={onPaymentDateSelect}
                                    />
                                </Form.Item>
                                <Form.Item name="date_of_pay" hidden={true}>
                                    <Input type="text" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="payment_modes"
                                    label="Receipt Mode"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Payment mode is required",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select Mode"
                                        size="large"
                                        allowClear
                                        onSelect={(value, event) => onSelectPaymentMode(value, event)}
                                    >
                                        <Option value="0">Select</Option>
                                        {paymentModeList.map(payment_mode_list => (
                                            <Option
                                                key={payment_mode_list.id}
                                                value={payment_mode_list.id}

                                                id={payment_mode_list.id}
                                                payment_mode={payment_mode_list.payment_mode}
                                                account_id={payment_mode_list.account_id}
                                                account_name={payment_mode_list.account_name}
                                                is_bank_details={payment_mode_list.is_bank_details}
                                                bank_charges={payment_mode_list.bank_charges}
                                            >
                                                {payment_mode_list.payment_mode}
                                                {payment_mode_list.bank_charges > 0 ? ` (${payment_mode_list.bank_charges}%)` : ""}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item name="selected_payment_mode_text" label="" hidden={true} >
                                    <Input type="text" />
                                </Form.Item>

                                <Form.Item name="dr_account_id" label="" hidden={true} >
                                    <Input type="text" />
                                </Form.Item>
                                <Form.Item name="payment_data" label="" hidden={true} >
                                    <Input type="text" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="paid_amount"
                                    label="Amount"
                                    onChange={() => onPaymentAmountChange(null)}
                                >
                                    <Input
                                        placeholder="Amount"
                                        size="large"
                                        readOnly
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={9} hidden={true} >
                                <Form.Item name="payment_ref" label="Transaction / Reference Numbers / Card Details" >
                                    <TextArea maxLength={100} rows={1} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="cheque_no"
                                    label="Ref. No"
                                >
                                    <Input size="large" readOnly={isPaymentModereadOnlyDisable} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item name="cheque_date" label="" hidden={true} >
                                    <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                                </Form.Item>
                                <Form.Item
                                    name="cheque_date_picker"
                                    label="Cheque Date"
                                >
                                    <DatePicker
                                        format={DATE_FORMAT_DMY_SLASH}
                                        style={{ width: "100%" }}
                                        inputReadOnly
                                        onChange={onChequeDateSelect}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={6}>
                                <Form.Item
                                    name="bank_name"
                                    label="Bank"
                                >
                                    <Select
                                        placeholder="Select Bank"
                                        size="large"
                                        allowClear
                                        showSearch
                                        onChange={handleBankChange}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                    >
                                        <Option value="0">Select</Option>
                                        {bankList.map(bank => (
                                            <Option
                                                key={bank.bank_id}
                                                value={bank.bank_name}
                                            >
                                                {bank.bank_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={4} hidden={true}>
                                <Form.Item name="branch" label="Branch" >
                                    <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                                </Form.Item>
                                <Form.Item name="bank_charges" label="Bank Charges" hidden={true} >
                                    <Input type="text" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span style={{
                                    color: "#22661c",
                                    fontWeight: "700",
                                    fontSize: "13px"
                                }}>{extraaPaidAmountInfo}</span>
                            </Col>
                            {/* <Col xs={24} xl={24} ><span>Note: Payment Mode , Amount should not be blank </span></Col> */}
                        </Row>

                        {/* Save Button */}
                        <Row justify="end" style={{ marginTop: '20px' }}>
                            <Col>
                                <Form.Item>
                                    <Button
                                        className="custom-button-green"

                                        size="large"
                                        htmlType="submit"
                                        icon={<RightOutlined />}
                                        disabled={isSaveDisabled}
                                        loading={saveLoaderEnable}
                                    >
                                        Save
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>

        </div>
    )
}

export default StudentDueEntry